// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaStickyNote, FaDesktop, FaCog, FaAndroid, FaCheck } from 'react-icons/fa';
import { IoIosColorPalette } from "react-icons/io";
import styles from "./welcomePanel.module.css";



// IMPORTAÇÃO DOS COMPONENTES ---------------------------------------------------------------------
import { useAppContext } from "../../../AppContext.js";


const WelcomePanel = ({ onCancel }) => {
    const { t } = useTranslation();
    const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site
    const [currentSlide, setCurrentSlide] = useState(0);
    const [viewMode, setViewMode] = useState('single');
    // dragging/swiping state
    const [dragStartX, setDragStartX] = useState(null);
    const [dragEndX, setDragEndX] = useState(null);



    // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
    useEffect(() => {
        document.body.style.overflow = "hidden";
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onCancel();
            }
        };
        window.addEventListener("keydown", handleEsc);

        // Função de limpeza
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", handleEsc);
        };
    }, [onCancel]);



    // Animação automática para alternar entre os modos de visualização
    useEffect(() => {
        const interval = setInterval(() => {
            setViewMode(prev => {
                if (prev === 'single') return 'double';
                if (prev === 'double') return 'grid';
                return 'single';
            });
        }, 4000);
        return () => clearInterval(interval);
    }, []);



    // Funções para navegação entre os slides
    const nextSlide = () => {
        if (currentSlide < 3) setCurrentSlide(currentSlide + 1);
    };

    const prevSlide = () => {
        if (currentSlide > 0) setCurrentSlide(currentSlide - 1);
    };

    // drag / swipe handlers
    const handleMouseDown = (e) => {
        e.preventDefault(); // avoid text selection while dragging
        setDragStartX(e.clientX);
    };

    const handleMouseMove = (e) => {
        if (dragStartX !== null) {
            setDragEndX(e.clientX);
        }
    };

    const handleMouseUp = () => {
        if (dragStartX !== null && dragEndX !== null) {
            const diff = dragStartX - dragEndX;
            if (diff > 50) nextSlide();
            else if (diff < -50) prevSlide();
        }
        setDragStartX(null);
        setDragEndX(null);
    };

    const handleTouchStart = (e) => {
        setDragStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (dragStartX !== null) {
            setDragEndX(e.touches[0].clientX);
        }
    };

    const handleTouchEnd = () => {
        if (dragStartX !== null && dragEndX !== null) {
            const diff = dragStartX - dragEndX;
            if (diff > 50) nextSlide();
            else if (diff < -50) prevSlide();
        }
        setDragStartX(null);
        setDragEndX(null);
    };



    return (
        <div className={styles.overlay}>
            <div
                className={styles.sliderContainer}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div className={styles.slider} style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                    {/* Primeiro Card - Boas vindas */}
                    <div className={`${styles.welcomeCard} ${!isApp ? styles.welcomeCardWeb : ''}`}>
                        <div className={styles.iconContainer}>
                            <FaStickyNote className={styles.icon} />
                        </div>
                        <h1 className={styles.title}>{t('welcomePanel.title')}</h1>
                        <p className={styles.description}>{t('welcomePanel.description')}</p>

                        {/* vantagens do tS notes */}
                        <ul className={styles.featuresList}>
                            {/* <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature1')}</li> */}
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature2')}</li>
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature3')}</li>
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature4')}</li>
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature5')}</li>
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature6')}</li>
                            <li><FaCheck className={styles.featureIcon} />{t('welcomePanel.feature7')}</li>
                        </ul>
                    </div>
                    {/* Segundo Card - disponibilidade */}
                    <div className={`${styles.welcomeCard} ${!isApp ? styles.welcomeCardWeb : ''}`}>
                        <div className={styles.iconContainer}>
                            {isApp ? <FaDesktop className={styles.icon} /> : <FaAndroid className={`${styles.icon} ${styles.androidIcon}`} />}
                        </div>
                        <h1 className={styles.title}>{isApp ? t('welcomePanel.desktopTitle') : t('welcomePanel.appTitle')}</h1>
                        <p className={styles.description}>{isApp ? t('welcomePanel.desktopDescription') : t('welcomePanel.appDescription')}</p>
                        {isApp ? (
                            <p className={styles.linkSite}>
                                www.tsnotes.toskyapps.com
                            </p>
                        ) : (
                            <p className={styles.linkSite}>
                                https://play.google.com/store/apps/details?id=com.toskyapps.tsnotes
                            </p>
                        )}
                    </div>
                    {/* Terceiro Card - modos de visualização*/}
                    <div className={`${styles.welcomeCard} ${!isApp ? styles.welcomeCardWeb : ''}`}>
                        <div className={styles.iconContainer}>
                            <FaCog className={styles.icon} />
                        </div>
                        <h1 className={styles.title}>{t('welcomePanel.configTitle')}</h1>
                        <p className={styles.description}>{t('welcomePanel.configDescription')}</p>
                        <div className={`${styles.viewAnimation} ${styles[viewMode]}`}>

                            {/* Nota Única */}
                            <div className={styles.noteUnica}>
                                <div className={styles.noteTitle}>{t('welcomePanel.noteTitle1')}</div>
                                <div className={styles.noteContent}>
                                    {t('welcomePanel.noteContent1')}<br /><br />
                                    {t('welcomePanel.noteContent1a')}
                                </div>
                            </div>

                            {/* Nota Dupla */}
                            <div className={styles.noteDupla}>
                                <div className={styles.noteDuplaChild}>
                                    <div className={styles.noteTitleDupla}>{t('welcomePanel.noteTitle1')}</div>
                                    <div className={styles.noteContentDupla}>
                                        {t('welcomePanel.noteContent1')}<br /><br />
                                        {t('welcomePanel.noteContent1a')}
                                    </div>
                                </div>
                                <div className={styles.noteDuplaChild}>
                                    <div className={styles.noteTitleDupla}>{t('welcomePanel.noteTitle2')}</div>
                                    <div className={styles.noteContentDupla}>
                                        {t('welcomePanel.noteContent2a')}<br />
                                        {t('welcomePanel.noteContent2b')}<br />
                                        {t('welcomePanel.noteContent2c')}<br />
                                    </div>
                                </div>
                            </div>

                            {/* Grade de Notas */}
                            <div className={styles.noteGrid}>
                                <div className={styles.noteGridChild}>
                                    <div className={styles.noteTitleGrid}>{t('welcomePanel.noteTitle1')}</div>
                                    <div className={styles.noteContentGrid}>
                                        {t('welcomePanel.noteContent1')}<br /><br />
                                        {t('welcomePanel.noteContent1a')}
                                    </div>
                                </div>
                                <div className={styles.noteGridChild}>
                                    <div className={styles.noteTitleGrid}>{t('welcomePanel.noteTitle2')}</div>
                                    <div className={styles.noteContentGrid}>
                                        {t('welcomePanel.noteContent2a')}<br />
                                        {t('welcomePanel.noteContent2b')}<br />
                                        {t('welcomePanel.noteContent2c')}<br />
                                    </div>
                                </div>
                                <div className={styles.noteGridChild}>
                                    <div className={styles.noteTitleGrid}>{t('welcomePanel.noteTitle3')}</div>
                                    <div className={styles.noteContentGrid}>
                                        {t('welcomePanel.noteContent3a')}<br />
                                        {t('welcomePanel.noteContent3b')}<br />
                                        {t('welcomePanel.noteContent3c')}<br />
                                    </div>
                                </div>
                                <div className={styles.noteGridChild}>
                                    <div className={styles.noteTitleGrid}>{t('welcomePanel.noteTitle4')}</div>
                                    <div className={styles.noteContentGrid}>
                                        {t('welcomePanel.noteContent4a')}<br />
                                        {t('welcomePanel.noteContent4b')}<br />
                                        {t('welcomePanel.noteContent4c')}<br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Quarto card - Possibilidades*/}
                    <div className={`${styles.welcomeCard} ${!isApp ? styles.welcomeCardWeb : ''}`}>
                        <div className={styles.iconContainer}>
                            <IoIosColorPalette className={styles.icon} />
                        </div>
                        <h1 className={styles.title}>{t('welcomePanel.possibilitiesTitle')}</h1>
                        <p className={styles.description}>{t('welcomePanel.possibilitiesDescription')}</p>
                        <div className={`${styles.viewAnimation} ${styles[viewMode]}`} style={{ backgroundColor: '#fff' }}>

                            {/* Nota Única */}
                            <div className={styles.noteUnica} style={{ backgroundColor: '#d5ecfa', boxShadow: 'none' }}>
                                <div className={styles.noteTitle} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>{t('welcomePanel.noteTitle1')}</div>
                                <div className={styles.noteContent} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>
                                    <span style={{
                                        display: 'inline-block',
                                        width: '16px',
                                        height: '16px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        marginRight: '8px',
                                        backgroundColor: '#ffffff55',
                                        verticalAlign: 'middle',
                                        position: 'relative',
                                        top: '-1px'
                                    }}></span>
                                    {t('welcomePanel.noteContent1')}<br /><br />
                                    <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '16px',
                                        height: '16px',
                                        backgroundColor: '#a855f7',
                                        borderRadius: '4px',
                                        marginRight: '8px',
                                        verticalAlign: 'middle',
                                        position: 'relative',
                                        top: '-1px'
                                    }}>
                                        <FaCheck size={10} color="#fff" />
                                    </span>
                                    {t('welcomePanel.noteContent1a')}
                                </div>
                            </div>

                            {/* Nota Dupla */}
                            <div className={styles.noteDupla}>
                                <div className={styles.noteDuplaChild} style={{ backgroundColor: '#d5ecfa', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleDupla} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>{t('welcomePanel.noteTitle1')}</div>
                                    <div className={styles.noteContentDupla} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>
                                        <span style={{
                                            display: 'inline-block',
                                            width: '12px',
                                            height: '12px',
                                            border: '1px solid #ccc',
                                            borderRadius: '3px',
                                            marginRight: '6px',
                                            backgroundColor: '#ffffff55',
                                            verticalAlign: 'middle',
                                            position: 'relative',
                                            top: '-1px'
                                        }}></span>
                                        {t('welcomePanel.noteContent1')}<br /><br />
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '12px',
                                            height: '12px',
                                            backgroundColor: '#a855f7',
                                            borderRadius: '3px',
                                            marginRight: '6px',
                                            verticalAlign: 'middle',
                                            position: 'relative',
                                            top: '-1px'
                                        }}>
                                            <FaCheck size={8} color="#fff" />
                                        </span>
                                        {t('welcomePanel.noteContent1a')}
                                    </div>
                                </div>
                                <div className={styles.noteDuplaChild} style={{ backgroundColor: '#e0e0e0', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleDupla} style={{ color: '#e607b6', fontFamily: 'Inconsolata, monospace' }}>{t('welcomePanel.noteTitle2')}</div>
                                    <div className={styles.noteContentDupla} style={{ color: '#e607b6', fontFamily: 'Inconsolata, monospace' }}>
                                        {t('welcomePanel.noteContent2a')}<br />
                                        {t('welcomePanel.noteContent2b')}<br />
                                        {t('welcomePanel.noteContent2c')}<br />
                                    </div>
                                </div>
                            </div>

                            {/* Grade de Notas */}
                            <div className={styles.noteGrid}>
                                <div className={styles.noteGridChild} style={{ backgroundColor: '#d5ecfa', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleGrid} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>{t('welcomePanel.noteTitle1')}</div>
                                    <div className={styles.noteContentGrid} style={{ color: '#a855f7', fontFamily: 'Edu NSW ACT Cursive, cursive' }}>
                                        <span style={{
                                            display: 'inline-block',
                                            width: '10px',
                                            height: '10px',
                                            border: '1px solid #ccc',
                                            borderRadius: '2px',
                                            marginRight: '4px',
                                            backgroundColor: '#ffffff55',
                                            verticalAlign: 'middle',
                                            position: 'relative',
                                            top: '-1px'
                                        }}></span>
                                        {t('welcomePanel.noteContent1')}<br /><br />
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#a855f7',
                                            borderRadius: '2px',
                                            marginRight: '4px',
                                            verticalAlign: 'middle',
                                            position: 'relative',
                                            top: '-1px'
                                        }}>
                                            <FaCheck size={6} color="#fff" />
                                        </span>
                                        {t('welcomePanel.noteContent1a')}
                                    </div>
                                </div>
                                <div className={styles.noteGridChild} style={{ backgroundColor: '#e0e0e0', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleGrid} style={{ color: '#e607b6', fontFamily: 'Inconsolata, monospace' }}>{t('welcomePanel.noteTitle2')}</div>
                                    <div className={styles.noteContentGrid} style={{ color: '#e607b6', fontFamily: 'Inconsolata, monospace' }}>
                                        {t('welcomePanel.noteContent2a')}<br />
                                        {t('welcomePanel.noteContent2b')}<br />
                                        {t('welcomePanel.noteContent2c')}<br />
                                    </div>
                                </div>
                                <div className={styles.noteGridChild} style={{ backgroundColor: '#fff', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleGrid} style={{ color: '#3b82f6', fontFamily: 'Roboto, sans-serif' }}>{t('welcomePanel.noteTitle3')}</div>
                                    <div className={styles.noteContentGrid} style={{ color: '#3b82f6', fontFamily: 'Roboto, sans-serif' }}>
                                        {t('welcomePanel.noteContent3a')}<br />
                                        {t('welcomePanel.noteContent3b')}<br />
                                        {t('welcomePanel.noteContent3c')}<br />
                                    </div>
                                </div>
                                <div className={styles.noteGridChild} style={{ backgroundColor: '#ffc6ea', boxShadow: 'none' }}>
                                    <div className={styles.noteTitleGrid} style={{ color: '#ef4444', fontFamily: 'Story Script, sans-serif' }}>{t('welcomePanel.noteTitle4')}</div>
                                    <div className={styles.noteContentGrid} style={{ color: '#ef4444', fontFamily: 'Story Script, sans-serif' }}>
                                        {t('welcomePanel.noteContent4a')}<br />
                                        {t('welcomePanel.noteContent4b')}<br />
                                        {t('welcomePanel.noteContent4c')}<br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.footer}>
                    <div className={styles.paginationDots}>
                        {[0, 1, 2, 3].map((dotIndex) => (
                            <div
                                key={dotIndex}
                                className={`${styles.dot} ${currentSlide === dotIndex ? styles.activeDot : ''}`}
                                onClick={() => setCurrentSlide(dotIndex)}
                            />
                        ))}
                    </div>
                    <button
                        className={styles.actionButton}
                        onClick={currentSlide === 3 ? onCancel : nextSlide}
                    >
                        {currentSlide === 3 ? t('Finish') : t('Continue')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WelcomePanel;